import angular from 'angular';
import router from 'angular-ui-router';

import guest from './_guest';
import landing from './landing';
import storeselector from './storeselector';
import notfound from './notfound';
import accessdenied from './accessdenied';

// Create module
const _moduleName = 'guest';
const _module = angular.module(_moduleName, [
    router
]);

// Register components
_module.config(guest);
_module.config(landing);
_module.config(storeselector);
_module.config(notfound);
_module.config(accessdenied);

// Export module name
export default _moduleName;



// WEBPACK FOOTER //
// ./src/js/components/guest/index.js